var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLastOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 5.75C18.5 5.33579 18.1642 5 17.75 5C17.3358 5 17 5.33579 17 5.75L17 18.25C17 18.6642 17.3358 19 17.75 19C18.1642 19 18.5 18.6642 18.5 18.25L18.5 5.75ZM7.53033 5.46967C7.23744 5.17678 6.76256 5.17678 6.46967 5.46967C6.17678 5.76256 6.17678 6.23744 6.46967 6.53033L11.9393 12L6.46967 17.4697C6.17678 17.7626 6.17678 18.2374 6.46967 18.5303C6.76256 18.8232 7.23744 18.8232 7.53033 18.5303L13.5303 12.5303C13.8232 12.2374 13.8232 11.7626 13.5303 11.4697L7.53033 5.46967Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLastOrange);
export default __webpack_public_path__ + "static/media/ArrowLastOrange.b38b1c96b7f70df6fb5d5fa75ee435fb.svg";
export { ForwardRef as ReactComponent };